var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1661 24.8325C20.0569 24.8325 24.8324 20.0571 24.8324 14.1662C24.8324 8.27543 20.0569 3.5 14.1661 3.5C8.27531 3.5 3.49988 8.27543 3.49988 14.1662C3.49988 20.0571 8.27531 24.8325 14.1661 24.8325Z",
    fill: "url(#paint0_radial_1414_3971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.1661 24.8325C20.0569 24.8325 24.8324 20.0571 24.8324 14.1662C24.8324 8.27543 20.0569 3.5 14.1661 3.5C8.27531 3.5 3.49988 8.27543 3.49988 14.1662C3.49988 20.0571 8.27531 24.8325 14.1661 24.8325Z",
    fill: "url(#paint1_radial_1414_3971)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9626 18.5022C13.9626 18.5022 16.1752 18.4923 16.9343 20.2535C16.9839 20.3626 17.0137 20.4817 17.0236 20.6057C17.0434 20.8488 16.8748 21.1018 16.4481 20.9381C15.7734 20.6751 14.6175 20.5363 13.9626 20.5363C13.3127 20.5363 12.1519 20.6702 11.4771 20.9381C11.0554 21.1018 10.8868 20.8488 10.9017 20.6057C10.9116 20.4817 10.9413 20.3626 10.9909 20.2535C11.75 18.4973 13.9626 18.5022 13.9626 18.5022Z",
    fill: "url(#paint2_radial_1414_3971)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 16.8703C11.2507 16.8703 11.7105 16.175 11.7105 15.3175C11.7105 14.4599 11.2507 13.7646 10.6836 13.7646C10.1164 13.7646 9.65662 14.4599 9.65662 15.3175C9.65662 16.175 10.1164 16.8703 10.6836 16.8703Z",
    fill: "url(#paint3_radial_1414_3971)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2766 14.7618C10.8769 14.7618 11.3779 15.377 11.5218 16.2104C11.6409 15.9574 11.7103 15.6499 11.7103 15.3175C11.7103 14.4592 11.249 13.7646 10.6834 13.7646C10.1922 13.7646 9.7805 14.2856 9.68127 14.9851C9.85988 14.8412 10.0633 14.7618 10.2766 14.7618Z",
    fill: "url(#paint4_linear_1414_3971)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58705 11.5371C8.66925 11.5371 7.88045 12.5938 8.90739 12.7575C9.93432 12.9212 11.8047 13.8043 12.5935 14.4145C12.653 14.484 12.8862 14.4641 12.8713 14.2805C12.8663 13.581 10.7033 11.5371 9.58705 11.5371Z",
    fill: "url(#paint5_linear_1414_3971)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9627 19.0826C13.9627 19.0826 15.7636 19.0776 16.9939 20.4617C16.979 20.3923 16.9592 20.3228 16.9295 20.2583C16.1704 18.4972 13.9578 18.5071 13.9578 18.5071C13.9578 18.5071 11.7451 18.4972 10.9861 20.2583C10.9564 20.3228 10.9365 20.3923 10.9216 20.4617C12.1569 19.0776 13.9627 19.0826 13.9627 19.0826Z",
    fill: "url(#paint6_linear_1414_3971)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6486 16.8703C18.2158 16.8703 18.6756 16.175 18.6756 15.3175C18.6756 14.4599 18.2158 13.7646 17.6486 13.7646C17.0815 13.7646 16.6217 14.4599 16.6217 15.3175C16.6217 16.175 17.0815 16.8703 17.6486 16.8703Z",
    fill: "url(#paint7_radial_1414_3971)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0554 14.7618C17.4552 14.7618 16.9541 15.377 16.8102 16.2104C16.6912 15.9574 16.6217 15.6499 16.6217 15.3175C16.6217 14.4592 17.0831 13.7646 17.6486 13.7646C18.1398 13.7646 18.5516 14.2856 18.6508 14.9851C18.4722 14.8412 18.2688 14.7618 18.0554 14.7618Z",
    fill: "url(#paint8_linear_1414_3971)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7452 11.5371C19.663 11.5371 20.4518 12.5938 19.4249 12.7575C18.398 12.9212 16.5276 13.8043 15.7388 14.4145C15.6793 14.484 15.4461 14.4641 15.461 14.2805C15.466 13.581 17.629 11.5371 18.7452 11.5371Z",
    fill: "url(#paint9_linear_1414_3971)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1414_3971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0675 9.84357) scale(12.8674 12.8674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1414_3971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0675 9.84357) scale(10.1234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1414_3971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9606 19.7472) scale(2.33546 1.2441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1414_3971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3721 15.355) rotate(73.8539) scale(1.50706 0.975044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1414_3971",
    x1: 10.6957,
    y1: 14.2373,
    x2: 10.6957,
    y2: 15.6276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1414_3971",
    x1: 10.6443,
    y1: 15.2277,
    x2: 10.6443,
    y2: 12.0052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1414_3971",
    x1: 13.9606,
    y1: 17.7416,
    x2: 13.9606,
    y2: 19.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1414_3971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9795 15.3385) rotate(106.146) scale(1.50706 0.975044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1414_3971",
    x1: 17.6363,
    y1: 14.2373,
    x2: 17.6363,
    y2: 15.6276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1414_3971",
    x1: 17.688,
    y1: 15.2277,
    x2: 17.688,
    y2: 12.0052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/Angry.016e2bf99499b8f6a854dc7a2172cb38.svg";
export { ForwardRef as ReactComponent };